import { COLORS } from "theme/tokens";
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
function collapseItem(theme, ownerState) {
  const { palette, transitions, breakpoints, boxShadows, borders, functions } = theme;
  const { active, transparentSidenav, whiteSidenav, darkMode, isParent, isOpen, isChild, miniSidenav } = ownerState;

  const { white, transparent, dark, grey } = palette;
  const { md } = boxShadows;
  const { borderRadius } = borders;
  const { pxToRem, rgba } = functions;

  const peachColor = COLORS.lighter;
  const blackColor = COLORS.black;
  const orangeActive = COLORS.main;

  // 2026-05-25 只看 active（父群組的 active = 是否含當前頁），不再因展開(isOpen)就 highlight
  const isHighlighted = active;

  return {
    background: isHighlighted ? peachColor : transparent.main,
    color: isHighlighted ? orangeActive : (whiteSidenav || transparentSidenav ? blackColor : white.main),
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start !important",
    width: miniSidenav ? "100%" : (isChild ? `calc(100% - ${pxToRem(48)})` : `calc(100% - ${pxToRem(32)})`),
    padding: miniSidenav ? `0` : `${pxToRem(4)} ${pxToRem(16)}`,
    margin: miniSidenav 
      ? `${pxToRem(4)} 0` 
      : (isChild ? `${pxToRem(4)} ${pxToRem(16)} ${pxToRem(4)} ${pxToRem(32)}` : `${pxToRem(4)} ${pxToRem(16)}`),
    borderRadius: "12px",
    cursor: "pointer",
    userSelect: "none",
    boxShadow: active && !whiteSidenav && !darkMode && !transparentSidenav ? md : "none",
    [breakpoints.up("xl")]: {
      transition: transitions.create(["box-shadow", "background-color"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.shorter,
      }),
    },

    "&:hover, &:focus": {
      backgroundColor: isHighlighted ? peachColor : rgba(grey[400], 0.1),
    },
  };
}
function collapseIconBox(theme, ownerState) {
  const { palette, transitions, functions } = theme;
  const { transparentSidenav, whiteSidenav, active, isParent, isOpen, isChild } = ownerState;

  const { white } = palette;
  const { pxToRem } = functions;
  const blackColor = COLORS.black;
  const orangeActive = COLORS.main;
  const isHighlighted = active;

  return {
    display: isChild ? "none" : "grid",
    minWidth: isChild ? 0 : pxToRem(32),
    minHeight: isChild ? 0 : pxToRem(32),
    width: isChild ? 0 : pxToRem(32),
    color: isHighlighted ? orangeActive : (transparentSidenav || whiteSidenav ? blackColor : white.main),
    borderRadius: "12px",
    placeItems: "center",
    transition: transitions.create("margin", {
      easing: transitions.easing.easeInOut,
      duration: transitions.duration.standard,
    }),

    "& svg, svg g": {
      color: isHighlighted ? orangeActive : (transparentSidenav || whiteSidenav ? blackColor : white.main),
    },
    "& img": {
      filter: isHighlighted 
        ? "invert(48%) sepia(82%) saturate(1200%) hue-rotate(344deg) brightness(98%) contrast(100%)"
        : "none",
    },
  };
}

const collapseIcon = ({ palette: { white } }, { active, isParent, isOpen, transparentSidenav, whiteSidenav }) => {
  const blackColor = COLORS.black;
  const orangeActive = COLORS.main;
  const isHighlighted = active;
  return {
    color: isHighlighted ? orangeActive : (transparentSidenav || whiteSidenav ? blackColor : white.main),
  };
};

function collapseText(theme, ownerState) {
  const { typography, transitions, breakpoints, functions } = theme;
  const { miniSidenav, transparentSidenav, active, isParent, isOpen, isChild } = ownerState;

  const { size, fontWeightBold } = typography;
  const { pxToRem } = functions;
  const isHighlighted = active;

  return {
    flex: 1,
    minWidth: 0,
    overflow: "hidden",
    marginLeft: isChild ? 0 : pxToRem(12),
    textAlign: "left",

    "& .MuiTypography-root": {
      textAlign: "left",
    },

    [breakpoints.up("xl")]: {
      opacity: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : 1,
      maxWidth: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : "100%",
      marginLeft: miniSidenav || (miniSidenav && transparentSidenav) ? 0 : pxToRem(12) + " !important",
      transition: transitions.create(["opacity", "margin"], {
        easing: transitions.easing.easeInOut,
        duration: transitions.duration.standard,
      }),
    },

    "& span": {
      fontWeight: fontWeightBold,
      fontSize: pxToRem(13),
      lineHeight: 1.3,
      color: "inherit",
      display: "block",
      textAlign: "left",
      marginLeft: "0 !important",
      // 2026-06-08 mini 時用 nowrap：文字容器 maxWidth:0，若 normal 會逐字斷行把項目撐很高
      //   （英文字多→更多行→更高，造成收合側欄圖示被撐開的 gap）。展開時恢復 normal 可換行。
      whiteSpace: miniSidenav ? "nowrap" : "normal",
      wordBreak: "break-word",
      paddingTop: pxToRem(2),
      paddingBottom: pxToRem(2),
    },
  };
}

export { collapseItem, collapseIconBox, collapseIcon, collapseText };
